import React, { useEffect, useState } from "react";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { useTranslation } from "react-i18next";
import useNewsFeedStore from "../NewsFeed/useNewsFeedStore";

const Auth = ({setProfileConfig ,profileConfig}) => {
  const [is2FAEnabled, setIs2FAEnabled] = useState(profileConfig?.has2F);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

console.log("profileConfig33333333333", profileConfig.has2F);

    // -------------------------------------------------------------------------
  const { setIsNewsPageLoaded } = useNewsFeedStore();

  useEffect(() => {
    setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed

    return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
  }, [setIsNewsPageLoaded]);

  // keep local toggle in sync if profileConfig.has2F changes externally
  useEffect(() => {
    setIs2FAEnabled(Boolean(profileConfig?.has2F));
  }, [profileConfig?.has2F]);

  // -------------------------------------------------------------------------

  
  const send2FARequest = () => {
    const sessionId = localStorage.getItem("sessionId");
    const language = localStorage.getItem("Lang");
    const token = localStorage.getItem("token");

    if (!sessionId || !token) {
      setErrorToastMessage("Authentication error. Please log in again.");
      setShowErrorToast(true);
      return;
    }
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: language,
    };

    setLoading(true);
    axios
      .post(`/Account/EnableDisable2FA`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setToastMessage(response?.data?.message || "2FA Updated Successfully");
        setShowToast(true);
        const enabled = response?.data?.is2FAEnabled ?? response?.data?.isEnabled;
        let newVal;
        if (typeof enabled === "boolean") {
          newVal = enabled;
          setIs2FAEnabled(enabled);
        } else {
          newVal = !is2FAEnabled;
          setIs2FAEnabled(newVal);
        }
        if (typeof setProfileConfig === "function") {
          setProfileConfig((prev) => ({ ...(prev || {}), has2F: newVal }));
        }
      })
      .catch((error) => {
        const msg = error?.response?.data?.message || "Something went wrong";
        if (error?.response?.status === 404) {
          setWarningToastMessage(msg);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(msg);
          setShowErrorToast(true);
        }
      })
      .finally(() => setLoading(false));
  };
  // -------------------------------------------------------------------------
  // fetch current 2FA status on mount so the toggle reflects server state
  // useEffect(() => {
  //   const fetch2FAStatus = async () => {
  //     const sessionId = localStorage.getItem("sessionId");
  //     const token = localStorage.getItem("token");
  //     const language = localStorage.getItem("Lang");
  //     if (!sessionId || !token) return;
  //     try {
  //       const response = await axios.get(`/Account/Get2FAStatus`, {
  //         headers: { Authorization: `Bearer ${token}` },
  //         params: { sessionId, langKey: language },
  //       });
  //       const data = response?.data || {};
  //       const enabled =
  //         data?.is2FAEnabled ?? data?.isEnabled ?? data?.data?.is2FAEnabled ??
  //         (data?.status === "enabled");
  //       const boolEnabled = Boolean(enabled);
  //       setIs2FAEnabled(boolEnabled);
  //       if (typeof setProfileConfig === "function") {
  //         setProfileConfig((prev) => ({ ...(prev || {}), has2F: boolEnabled }));
  //       }
  //     } catch (err) {
  //       // ignore; leave toggle false if we can't determine status
  //     }
  //   };

  //   fetch2FAStatus();
  // }, []);
  return (
    <>
      <div className="setting-header">
        <h4>{t("User Profile.2FA Authentication")}</h4>
      </div>
      <div className="p-3 privacy">
        <div className="d-flex align-items-center justify-content-between">
          <p className="sessionName">{t("User Profile.Enable Two-Factor Authentication")}</p>
          <div className="form-check form-switch">
            <input
              className="form-check-input custom-toggle"
              type="checkbox"
               role="switch"
              id="flexSwitchCheckChecked"
              checked={is2FAEnabled}
              onChange={send2FARequest}
              disabled={loading}
            />
          </div>
        </div>

        {showToast && <div className="toast success">{toastMessage}</div>}
        {showErrorToast && (
          <div className="toast error">{ErrorToastMessage}</div>
        )}
      </div>

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default Auth;
